function appendTokenToUrl(url, token) {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    params.set('token', token);
    urlObj.search = params.toString();
    return urlObj.toString();
}

function replaceImageSrcWithMoodleUrl(htmlString, baseUrlWithToken) {
    const container = document.createElement('div');
    container.innerHTML = htmlString;

    const url = new URL(baseUrlWithToken);
    const token = url.searchParams.get('token');

    // Xóa index.html ở cuối URL gốc
    const basePath = url.pathname.replace(/index\.html$/, '');
    const origin = url.origin;

    const images = container.querySelectorAll('img');

    images.forEach(img => {
        const filename = img.getAttribute('src')?.split('?')[0] || img.getAttribute('src');
        const newSrc = `${origin}${basePath}${filename}?token=${token}`;
        img.setAttribute('src', newSrc);
        img.setAttribute('width', '100%');
    });

    return container.innerHTML;
}

function replacePluginfileUrlsWithToken(content, token) {
  let container;

  // Nếu là chuỗi HTML → chuyển thành DOM node
  if (typeof content === 'string') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    container = doc.body;
  } else if (content instanceof Element) {
    container = content;
  } else {
    console.error('Invalid content: must be HTML string or DOM element');
    return;
  }

  const images = container.querySelectorAll('img[src*="pluginfile.php/"]');

  images.forEach(img => {
    const originalSrc = img.getAttribute('src');

    try {
      const url = new URL(originalSrc);
      const moodleDomain = `${url.protocol}//${url.host}`;
      const pluginfileIndex = url.pathname.indexOf('/pluginfile.php/');
      
      if (pluginfileIndex !== -1) {
        const filePath = url.pathname.substring(pluginfileIndex + '/pluginfile.php'.length);
        const newSrc = `${moodleDomain}/webservice/pluginfile.php?file=${filePath}&token=${token}`;
        img.setAttribute('src', newSrc);
      }

      // Xử lý width và style
      const originalWidth = img.getAttribute('width') || img.width || img.naturalWidth;

      img.setAttribute('width', '100%');
      if (originalWidth) {
        img.setAttribute('style', `max-width: ${originalWidth}px; height: auto;`);
      } else {
        img.setAttribute('style', `height: auto;`);
      }

    } catch (e) {
      console.warn('Invalid image URL:', originalSrc);
    }
  });

  // Nếu đầu vào là chuỗi → trả lại chuỗi HTML đã sửa
  if (typeof content === 'string') {
    return container.innerHTML;
  }
}

function getWatchTimeByDay(timestamps, intervalTime = 15000, targetDate = null) {
    const watchByDay = {};

    timestamps.forEach(ts => {
        const date = new Date(ts).toISOString().split('T')[0];
        if (!watchByDay[date]) {
            watchByDay[date] = 0;
        }
        watchByDay[date]++;
    });

    if (targetDate) {
        const count = watchByDay[targetDate] || 0;
        return (count * intervalTime) / 1000; // in seconds
    }

    // Nếu không truyền ngày thì trả về tất cả
    const result = {};
    for (const day in watchByDay) {
        result[day] = (watchByDay[day] * intervalTime) / 1000;
    }

    return result;
}

// Hàm kiểm tra xem mốc thời gian có thuộc ngày targetDate hay không
function isValidDate(timestamp, targetDate) {
    const date = new Date(timestamp);
    const target = new Date(targetDate);

    // So sánh năm, tháng, ngày
    return date.getFullYear() === target.getFullYear() &&
        date.getMonth() === target.getMonth() &&
        date.getDate() === target.getDate();
}

// Lấy khoảng thời gian đầu ngày và cuối ngày theo UTC+7 (trả về ms UTC)
function getTodayRangeUTC7() {
    const now = new Date();
    const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
    const utc7 = new Date(utcMs + 7 * 3600000);
    const year = utc7.getFullYear();
    const month = utc7.getMonth();
    const day = utc7.getDate();
    const startMs = Date.UTC(year, month, day) - 7 * 3600000;
    const endMs = startMs + 24 * 3600000;
    return { startMs, endMs };
}

// Kiểm tra timestamp (ms) có thuộc ngày hiện tại theo UTC+7
function isTimestampTodayUTC7(timestampMs) {
    const { startMs, endMs } = getTodayRangeUTC7();
    return timestampMs >= startMs && timestampMs < endMs;
}

// Lấy ngày hiện tại theo UTC+7 dạng YYYY-MM-DD
function getTodayStringUTC7() {
    const now = new Date();
    const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
    const utc7 = new Date(utcMs + 7 * 3600000);
    const year = utc7.getFullYear();
    const month = String(utc7.getMonth() + 1).padStart(2, '0');
    const day = String(utc7.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// Hàm tính tổng thời gian học từ mảng mapa cho một ngày cụ thể
function calculateSupervideoLearningTime(mapa, targetDate, intervalTime) {
    let validTimestampsCount = 0;

    // Đếm số lượng mốc thời gian hợp lệ cho targetDate
    mapa.forEach(timestamp => {
        if (timestamp > 0 && isValidDate(timestamp, targetDate)) {
            validTimestampsCount += 1;
        }
    });

    // Tổng thời gian = số phần tử hợp lệ * intervalTime (tính bằng giây hoặc phút)
    return validTimestampsCount * intervalTime;
}

// Tính thời gian học cho các bài quiz (tương tự như phần trước)
function calculateQuizLearningTime(quiz, targetDate, elearningSetting, quizAttempts) {
    if (quiz.quiztimelimit && quiz.finalgrade >= quiz.gradepass && isValidDate(quiz.lastmodified * 1000, targetDate)) {
        return quiz.quiztimelimit;
    } else if (quiz.quiztimelimit === 0) {
        // Nếu quiz không có thời gian giới hạn, tính thời gian dựa trên số câu hỏi đã trả lời
        const timeSpent =
            quizAttempts?.[quiz?.cminstance]?.attempts?.map(attempt => {
                const questionsAnswered = attempt?.questionsAnswered || 0;
                const timePerQuestion = elearningSetting?.timePerQuestionInMinute || 0; // Thời gian cho mỗi câu hỏi (tính bằng phút)
                if (isValidDate(attempt?.timeFinish * 1000, targetDate)) {
                    return questionsAnswered * timePerQuestion * 60; // Chuyển đổi sang giây
                }
                return 0; // Nếu không hợp lệ, trả về 0
            }).reduce((acc, time) => acc + time, 0) || 0; // Tổng thời gian cho tất cả các câu hỏi đã trả lời
        return timeSpent;
    }
    return 0;
}

// Tính thời gian học book từ dữ liệu student-data
// Nếu có mapa: lọc timestamp thuộc ngày hiện tại (UTC+7), đếm × interval
// Nếu không có mapa: dùng timeSpentInSecond
// bookModuleSettings: { [moduleId]: { [chapterId]: { interval, readingTime } } }
function calculateBookLearningTime(bookMapaData, targetDate, intervalTimeOrSettings) {
    if (!Array.isArray(bookMapaData) || bookMapaData.length === 0) return 0;

    const isSettingsMap = typeof intervalTimeOrSettings === 'object' && intervalTimeOrSettings !== null;
    const fallbackInterval = isSettingsMap ? 30 : intervalTimeOrSettings;

    let totalTime = 0;

    bookMapaData.forEach((record) => {
        const mapa = record?.mapa;
        const interval = isSettingsMap
            ? (intervalTimeOrSettings?.[record?.moduleId]?.[record?.chapterId]?.interval || fallbackInterval)
            : fallbackInterval;

        if (Array.isArray(mapa) && mapa.length > 0) {
            // Có mapa: lọc timestamp thuộc ngày hiện tại (UTC+7), đếm × interval
            let validCount = 0;
            mapa.forEach((ts) => {
                if (ts > 0 && isTimestampTodayUTC7(ts * 1000)) {
                    validCount += 1;
                }
            });
            totalTime += validCount * interval;
        } else {
            // Không có mapa: dùng timeSpentInSecond
            totalTime += record?.timeSpentInSecond || 0;
        }
    });

    return totalTime;
}

// Hàm tính tổng thời gian học cho một ngày (targetDate) từ supervideo, quiz và book
function calculateTotalLearningTimeForDate(
    { data, targetDate, intervalTime, elearningSetting, quizAttempts, bookMapaData, bookModuleSettings } // intervalTime tính bằng giây (supervideo)
) {
    let totalTime = 0;

    Object.values(data || {}).forEach((module) => {
        if (module.modname === 'supervideo') {
            totalTime += calculateSupervideoLearningTime(module.mapa, targetDate, intervalTime);
        } else if (module.modname === 'quiz') {
            totalTime += calculateQuizLearningTime(module, targetDate, elearningSetting, quizAttempts);
        }
    })

    // Cộng thêm thời gian từ book mapa (dùng bookModuleSettings nếu có, fallback 30)
    if (bookMapaData) {
        totalTime += calculateBookLearningTime(bookMapaData, targetDate, bookModuleSettings || 30);
    }

    return totalTime;
}

const groupCourseContent = (sections = []) => {
    const modulesMap = {};

    if (!Array.isArray(sections) || sections.length === 0) {
        return modulesMap;
    }

    sections.forEach(section => {
        section?.modules?.forEach(module => {
            modulesMap[module.id] = module;
        });
    });

    return modulesMap;
};

const groupUserGradeByCourseModule = (data) => {
    const grouped = {};

    data.forEach(item => {
        const userId = item.userid;
        const courseId = item.courseid;
        let moduleid = item.cmid;

        if (!grouped[userId]) {
            grouped[userId] = {
                username: item.username,
                name: `${item.firstname} ${item.lastname}`,
                email: item.email,
                courses: {}
            };
        }

        if (!grouped[userId].courses[courseId]) {
            grouped[userId].courses[courseId] = {
                courseid: courseId,
                coursename: item.coursename,
                modules: {}
            };
        }

        grouped[userId].courses[courseId].modules[moduleid] = {
            cmid: item.cmid,
            cminstance: item.cminstance,
            itemname: item.itemname,
            svname: item.svname,
            finalgrade: item.finalgrade,
            gradepass: item.gradepass,
            grademin: item.grademin,
            grademax: item.grademax,
            duration: item.duration,
            quizsumgrades: item.quizsumgrades,
            quiztimelimit: item.quiztimelimit,
            mapa: item.mapa,
            modname: item.itemmodule,
            lastmodified: item?.lastmodified,
        };
    });

    return grouped;
}

// Parse HTML câu hỏi Cloze (qtype multianswer) — dùng cho học phần Mô Phỏng:
// 1 câu = 1 video tình huống + 4 sub-question radio (fieldset.answer, input
// name dạng `q{qubaid}:{slot}_sub{N}_answer`). Trả về shape riêng để
// ClozeQuestionItem render — KHÔNG đi qua nhánh multichoice thường.
const parseClozeQuestionHTML = (doc, questionId) => {
    // Video: filter videojs của Moodle bọc <video> gốc và chuyển src vào
    // <source>. Lấy URL từ source trước, fallback video[src].
    const videoEl = doc.querySelector('.formulation video');
    const videoUrl = videoEl?.querySelector('source')?.getAttribute('src')
        || videoEl?.getAttribute('src') || '';
    const situationId = doc.querySelector('.sim-situation')?.getAttribute('data-situation-id') || null;

    // Mỗi fieldset.answer = 1 sub-question. Label section (p.sim-section) là
    // sibling đứng trước fieldset trong stem do generator sinh ra.
    const sectionLabels = Array.from(doc.querySelectorAll('.sim-section')).map((el) => (el.textContent || '').trim());
    const subQuestions = Array.from(doc.querySelectorAll('.formulation fieldset.answer')).map((fs, i) => {
        const radios = Array.from(fs.querySelectorAll('input[type="radio"]'));
        // Tên input thật từ Moodle (vd q473419:1_sub1_answer) — dùng nguyên
        // vẹn làm key payload khi save, không tự ghép để khỏi lệch format.
        const inputName = radios[0]?.getAttribute('name') || '';
        const options = radios.map((input) => {
            const wrap = input.closest('.form-check');
            const classList = (wrap?.className || '').split(/\s+/);
            const label = fs.querySelector(`label[for="${input.id}"]`)?.textContent?.trim()
                || wrap?.textContent?.trim() || '';
            return {
                label,
                value: input.getAttribute('value') ?? '',
                checked: input.checked || input.hasAttribute('checked'),
                // Chỉ có trong HTML XEM LẠI của Moodle: div.form-check.correct =
                // đáp án đúng; .incorrect = lựa chọn SAI mà học viên đã chọn.
                isCorrect: classList.includes('correct'),
                isWrongChoice: classList.includes('incorrect'),
            };
        });
        // Khối .outcome đứng NGAY SAU fieldset (chứa điểm phần + dòng "Đáp án
        // đúng: <nhãn>"). Lưu ý: trình duyệt tự đóng <p> khi gặp <fieldset>/<div>
        // nên outcome là sibling của fieldset (không phải con chung <p>) — phải
        // dò nextElementSibling, KHÔNG dùng parentElement.querySelector (sẽ luôn
        // trúng .outcome của phần đầu tiên). Dừng khi sang fieldset/section kế.
        let outcomeEl = null;
        for (let sib = fs.nextElementSibling; sib; sib = sib.nextElementSibling) {
            if (sib.classList?.contains('outcome')) { outcomeEl = sib; break; }
            if (sib.tagName === 'FIELDSET' || sib.classList?.contains('sim-section')) break;
        }
        const outcomeText = (outcomeEl?.textContent || '').replace(/\s+/g, ' ').trim();
        const m = outcomeText.match(/Đáp án đúng:\s*(.+)$/);
        const correctLabel = (m ? m[1] : (options.find((o) => o.isCorrect)?.label || '')).trim();
        const chosen = options.find((o) => o.checked) || null;
        // true = đúng, false = sai, null = không có dữ liệu chấm (đang làm bài).
        let chosenCorrect = null;
        if (chosen) {
            if (chosen.isCorrect) chosenCorrect = true;
            else if (chosen.isWrongChoice) chosenCorrect = false;
            else if (correctLabel) chosenCorrect = chosen.label === correctLabel;
        }
        return {
            index: i + 1,
            label: sectionLabels[i] || `Phần ${i + 1}`,
            inputName,
            options,
            correctLabel,
            chosenCorrect,
        };
    });

    const feedback = doc.querySelector('.generalfeedback')?.innerHTML?.trim() || '';
    const rightAnswer = doc.querySelector('.rightanswer')?.innerHTML?.trim() || '';

    return {
        id: questionId,
        type: 'multianswer',
        videoUrl,
        situationId,
        subQuestions,
        feedback,
        rightAnswer,
    };
};

const parseQuestionHTML = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    // Lấy ID câu hỏi (từ thẻ div id="question-XXX")
    const questionWrapper = doc.querySelector('[id^="question-"]');
    const questionId = questionWrapper?.id?.split('-')[1] || null;

    // Cloze (multianswer) có shape khác hẳn — parse riêng
    if (questionWrapper?.classList?.contains('multianswer')) {
        return parseClozeQuestionHTML(doc, questionId);
    }

    // Lấy nội dung câu hỏi
    const questionTextElement = doc.querySelector('.qtext');
    const questionText = questionTextElement?.innerHTML?.trim() || '';

    // Lấy danh sách đáp án
    const answerElements = doc.querySelectorAll('.answer .d-flex');
    const allInputElements = doc.querySelectorAll('input[type="radio"]');

    const answers = Array.from(answerElements).map((el, idx) => {
        const input = allInputElements[idx];
        const label = el.innerText.trim();
        const value = input?.value || '';
        const checked = input?.checked || false;
        return { label, value, checked };
    });

    const feedbackElement = doc.querySelector('.generalfeedback');
    const feedback = feedbackElement?.innerHTML?.trim() || '';
    const rightAnswerElement = doc.querySelector('.rightanswer');
    const rightAnswer = rightAnswerElement?.innerHTML?.trim() || '';

    // Trả về đối tượng tương thích React component
    return {
        id: questionId,
        text: questionText,
        answers: answers,
        feedback: feedback,
        rightAnswer: rightAnswer,
    };
};

export { groupUserGradeByCourseModule, getWatchTimeByDay, calculateTotalLearningTimeForDate, calculateSupervideoLearningTime, calculateQuizLearningTime, calculateBookLearningTime, groupCourseContent, replaceImageSrcWithMoodleUrl, appendTokenToUrl, isValidDate, isTimestampTodayUTC7, getTodayStringUTC7, getTodayRangeUTC7, replacePluginfileUrlsWithToken, parseQuestionHTML };
